import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { InterfaceFilter, TimeRangeFilter, useInterface, useInterfaceName } from '../../filters';
import {
    InterfaceCbqosPanel,
    InterfaceDiscardsPanel,
    InterfaceErrorsPanel,
    InterfacePacketsPanel,
    InterfacePropertiesPanel,
    InterfaceUtilizationPanel,
    InterfaceStatusPanel,
} from '../../panels';
import { LAYOUT_WIDTH } from '../../page-framework/panel-container/PanelContainer';

export const pageId = 'interface-detail';

export default function InterfaceDetailPage() {
    const title = useInterfaceName();
    const intf = useInterface();

    return (
        <Page id={pageId}>
            <PageHeader title={title}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <InterfaceFilter required />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <InterfaceStatusPanel width={LAYOUT_WIDTH.FULL} title={t`Status`} />
                <InterfaceUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`Utilization`} />
                <InterfacePacketsPanel width={LAYOUT_WIDTH.HALF} title={t`Packets`} />
                <InterfaceErrorsPanel width={LAYOUT_WIDTH.HALF} title={t`Errors`} />
                <InterfaceDiscardsPanel width={LAYOUT_WIDTH.HALF} title={t`Total Discards`} />
                {intf?.hasCbQosClasses && <InterfaceCbqosPanel width={LAYOUT_WIDTH.FULL} />}
                <InterfacePropertiesPanel width={LAYOUT_WIDTH.FULL} title={t`Properties`} />
            </PanelContainer>
        </Page>
    );
}
